import { render, staticRenderFns } from "./the-credit.vue?vue&type=template&id=71f19e4c&scoped=true"
import script from "./the-credit.vue?vue&type=script&lang=js"
export * from "./the-credit.vue?vue&type=script&lang=js"
import style0 from "./the-credit.vue?vue&type=style&index=0&id=71f19e4c&prod&scoped=true&lang=css"
import style1 from "./the-credit.vue?vue&type=style&index=1&id=71f19e4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f19e4c",
  null
  
)

export default component.exports